import script from "./ShowServiceModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShowServiceModal.vue?vue&type=script&setup=true&lang=ts"

import "./ShowServiceModal.vue?vue&type=style&index=0&id=4d2b400c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d2b400c"]])

export default __exports__